<template>
    <div class="driverManage">
       <router-view></router-view>
    </div>
</template>


<script>
export default {
  name: "driverManage",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
